import React from "react";
import background from "../../images/BlogHeadingBackGround.jpg";
import Head from "../../components/Head";
import ContentBelow from "../../components/ContentBelow";
import classes from "../../components/FAQ.module.css";
import { useState, useMemo } from "react";
import RafClaimImg from "../../images/FAQ/RAF-Claim Process.png";
import FAQData from "./FAQData";
import { Link } from "react-router-dom";
import FAQTreeView from "./FAQTreeView";
import FAQList from "./FAQList";

export default function FAQ() {
  const [search, setSearch] = useState("");

  const filterFAQ = FAQData.filter((faq) =>
    faq.question.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <>
      <Head imageUrl={background}>
        <h2 className="heading_space">FAQs</h2>
      </Head>

      <ContentBelow AddStyle={" bg-light"}>
        <div className="col-lg-11 mt-4 mx-auto">
          <h2 className={classes.h2}>
            Frequently Asked{" "}
            <span className="" style={{ color: "#68B0ED" }}>
              Questions
            </span>
          </h2>
          <p className=" text-center">
            Got questions? Our FAQs have the answers!
          </p>
        </div>

        <div className="container my-3 mx-auto bg-light">
          <div className="row align-items-start">
            {/* LEFT: Recent FAQs */}
            <aside className="col-md-3 p-3 rounded">
              <FAQTreeView />
            </aside>

            {/* RIGHT: Search + FAQ List */}
            <main className=" col-md-9">
              {/* Search Bar */}
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search FAQ's"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>

              {/* FAQ List under search */}
              <FAQList post={search} />

              {/* Empty state */}
              {filterFAQ.length === 0 && (
                <p className="text-center text-muted mt-3">
                  No FAQ found matching your search.
                </p>
              )}
            </main>
          </div>
        </div>
      </ContentBelow>
    </>
  );
}
